import { StoreSelectorFunction } from '../../../../core/selector';
export default (): StoreSelectorFunction<string> => (): string => {
    return window.location.origin;
};
